import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const StoreStyles = {
  checkbox: (): SystemStyleObject<Theme> => ({
    "& .MuiSvgIcon-root": {
      borderRadius: "50%",
      border: "1px solid white",
      opacity: "50%",
      fontSize: "16px",
    },
    "& .Mui-checked": {
      "& .MuiSvgIcon-root": {
        border: "none",
        opacity: "100%",
        background: "linear-gradient(45deg, #ECA843 30%, #AD7E38 50%)",
      },
    },
  }),
};

export default StoreStyles;
